import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Update Workspace Name", -1)
const _hoisted_3 = { class: "card col-md-6" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  for: "name",
  class: "form-label"
}
const _hoisted_7 = { class: "card-footer" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.loading ? "Loading" : "Workspace Name"), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "name",
            placeholder: "Workspace Name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary ms-2 float-end",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          disabled: _ctx.submitted
        }, _toDisplayString(_ctx.submitted ? "Storing" : "Update"), 9, _hoisted_8)
      ])
    ])
  ]))
}